import { gsap } from 'gsap' ;
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el grupos');

    gsap.registerPlugin(ScrollTrigger, CSSPlugin, TextPlugin, ScrollToPlugin);

    let miGiro = gsap.to('#luzGrupo', {rotation: 360, duration: 5, ease: 'none', repeat: -1});

    miGiro.play();



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-grupos.js